import React, { useState } from 'react';
import styles from './ContactUs.module.css';
import {useNavigate, useParams} from "react-router-dom";

export default function ContactUs({ onBack, onSubmit }) {
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    content: '',
    subscribeNewsletter: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (onSubmit) {
      onSubmit(formData);
    }
  };

  return (
    <div className={styles.screenWrapper}>
      <div className={styles.deviceFrame}>

        {/* Top Navigation */}
        <header className={styles.appBar}>
          <button
            type="button"
            className={styles.backBtn}
           onClick={() => navigate(-1)}
            aria-label="Go Back"
          >
            <svg
              width="21"
              height="17"
              viewBox="0 0 24 18"
              fill="none"
              stroke="#0A529B"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 9H5" />
              <polyline points="11 2 4 9 11 16" />
            </svg>
          </button>

          <div className={styles.headerBadge}>
            <span className={styles.badgeDot}></span>
            Support
          </div>
        </header>

        {/* Scrollable Content */}
        <div className={styles.scrollContainer}>
          <main className={styles.contentSection}>

            {/* Premium Brand */}
            <div className={styles.brandContainer}>
              <span className={styles.brandBro}>Bro</span>
              <span className={styles.brandBizee}>Bizee</span>
              <span className={styles.brandDot}>.</span>
            </div>

            {/* Heading */}
            <div className={styles.headingBlock}>
              <span className={styles.eyebrow}>GET IN TOUCH</span>

              <h1 className={styles.pageTitle}>
                Contact <span>Us</span>
              </h1>

              <p className={styles.subtitle}>
                Have a question or need help?
                <br />
                We’re here to help you.
              </p>
            </div>

            {/* Contact Form Card */}
            <form
              onSubmit={handleSubmit}
              className={styles.formCard}
            >

              {/* Email */}
              <div className={styles.fieldGroup}>
                <label className={styles.fieldLabel}>
                  Email Address
                </label>

                <div className={styles.inputShell}>
                  <div className={styles.inputIcon}>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    >
                      <rect
                        x="3"
                        y="5"
                        width="18"
                        height="14"
                        rx="2"
                      />
                      <path d="m3 7 9 6 9-6" />
                    </svg>
                  </div>

                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    className={styles.inputField}
                    required
                  />
                </div>
              </div>

              {/* Name */}
              <div className={styles.fieldGroup}>
                <label className={styles.fieldLabel}>
                  Full Name
                </label>

                <div className={styles.inputShell}>
                  <div className={styles.inputIcon}>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    >
                      <circle cx="12" cy="8" r="4" />
                      <path d="M4 21c.8-4 3.5-6 8-6s7.2 2 8 6" />
                    </svg>
                  </div>

                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    className={styles.inputField}
                    required
                  />
                </div>
              </div>

              {/* Message */}
              <div className={styles.fieldGroup}>
                <label className={styles.fieldLabel}>
                  Message
                </label>

                <div className={`${styles.inputShell} ${styles.messageShell}`}>
                  <div className={styles.inputIcon}>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    >
                      <path d="M21 11.5a8.4 8.4 0 0 1-9 8.5 9.8 9.8 0 0 1-4-.8L3 21l1.8-4.4A8.4 8.4 0 0 1 3 11.5 8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5Z" />
                    </svg>
                  </div>

                  <textarea
                    name="content"
                    placeholder="Tell us how we can help..."
                    value={formData.content}
                    onChange={handleChange}
                    className={styles.textareaField}
                    rows={4}
                    required
                  />
                </div>
              </div>

              {/* Newsletter */}
              <label className={styles.checkboxContainer}>
                <input
                  type="checkbox"
                  name="subscribeNewsletter"
                  checked={formData.subscribeNewsletter}
                  onChange={handleChange}
                  className={styles.checkboxInput}
                />

                <span className={styles.checkboxCustom}>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </span>

                <span className={styles.checkboxLabel}>
                  I would like to receive the newsletter.
                </span>
              </label>

              {/* Submit */}
              <button
                type="submit"
                className={styles.submitBtn}
              >
                <span>Send Message</span>

                <span className={styles.submitIcon}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </span>
              </button>

            </form>

            {/* Social / Contact Footer */}
            <footer className={styles.socialFooter}>

              <div className={styles.footerLine}></div>

              <p className={styles.connectText}>
                Connect with BroBizee
              </p>

              <div className={styles.socialRow}>

                {/* Instagram */}
                <a
                  href="https://www.instagram.com/brobizee.com_2026/?hl=en"
                  className={styles.socialIcon}
                  aria-label="Instagram"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <rect
                      x="3"
                      y="3"
                      width="18"
                      height="18"
                      rx="5"
                    />
                    <circle cx="12" cy="12" r="4" />
                    <circle
                      cx="17.5"
                      cy="6.5"
                      r="1"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                </a>

                {/* Twitter / X */}
                <a
                  href="#twitter"
                  className={styles.socialIcon}
                  aria-label="Twitter"
                >
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <path d="M4 4l16 16" />
                    <path d="M20 4 4 20" />
                  </svg>
                </a>

                {/* Facebook */}
                <a
                  href="https://www.facebook.com/profile.php?id=61593640887253"
                  className={styles.socialIcon}
                  aria-label="Facebook"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M14 8h3V4h-3a5 5 0 0 0-5 5v3H6v4h3v5h4v-5h3l1-4h-4V9a1 1 0 0 1 1-1Z" />
                  </svg>
                </a>

                {/* YouTube */}
                <a
                  href="https://www.youtube.com/@BroBizee"
                  className={styles.socialIcon}
                  aria-label="YouTube"
                >
                  <svg
                    width="21"
                    height="21"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <rect
                      x="2"
                      y="5"
                      width="20"
                      height="14"
                      rx="4"
                    />
                    <polygon
                      points="10,9 16,12 10,15"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>
                </a>

              </div>

              <p className={styles.footerCopyright}>
                © 2026 BroBizee. All rights reserved.
              </p>

            </footer>

          </main>
        </div>

      </div>
    </div>
  );
}